import { Typography, Grid, withStyles, Theme, useTheme, useMediaQuery } from '@material-ui/core'
import suggestIcon from '../../../../images/suggest.svg'
import { MuiClasses } from '../../../../types'
type SuggestProps = {
  classes: MuiClasses;
  content?: string;
  containerMaxWidth?: string;
  contentMaxWidth?: string;
  isModal?: boolean;
  bigPaddingOnLargeScreens?: boolean;
  mediumPaddingOnLargeScreens?: boolean;
  padding?: string;
  suggestContainerPadding?: string
  desktopMaxWidth?: string
  // When true, on desktop align box to left instead of centered
  alignLeftOnDesktop?: boolean
}

const styles = ({ breakpoints }: Theme) => ({
  largeForm: {
    padding: '35px 0 15px 0',
    display: 'flex',
    justifyContent: 'center',
    justifySelf: 'center',
    margin: 0,
    [breakpoints.between('sm', 'md')]: {
      margin: 'auto'
    },
    [breakpoints.down('sm')]: {
      padding: '10px 0'
    },
    [breakpoints.up('lg')]: {
      display: 'flex'
    }
  },
  suggestContainer: {
    background: '#FBF6EE',
    padding: '25px 40px',
    display: 'flex',
    fontSize: '12px',
    borderRadius: '25px',
    // '> div': {
    //   display: 'flex'
    // },
    [breakpoints.up('xs')]: {
      padding: '25px'
    },
    '& img': {
      marginRight: '10px',
      marginBottom: '10px'
    }
  },
  suggestIcon: {
    float: 'left' as const,
    padding: '5px'
  },
  suggestText: {
    textAlign: 'left' as const,
    [breakpoints.up('md')]: {
      overflow: 'hidden'
    }
  }
})

const Suggest = ({
  classes,
  content,
  containerMaxWidth,
  contentMaxWidth,
  isModal,
  bigPaddingOnLargeScreens,
  mediumPaddingOnLargeScreens,
  padding,
  suggestContainerPadding, // Destructure padding prop
  desktopMaxWidth,
  alignLeftOnDesktop
}: SuggestProps) => {
  const theme = useTheme();
  const isLargeScreen = useMediaQuery(theme.breakpoints.up('sm'))
  const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'md'))
  const isMidDesktop = useMediaQuery(theme.breakpoints.between('md', 'lg'))
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'))
  // Full-width infoBox between 490px and 600px
  const isXsWide = useMediaQuery('(min-width:490px) and (max-width:599.95px)')
  const isFullWidth = (containerMaxWidth === '100%' && contentMaxWidth === '100%')

  return (
    <div
      className={classes.largeForm}
      style={{
        // Desktop width can be overridden via desktopMaxWidth; default to 650px
        maxWidth: isFullWidth
          ? '100%'
          : (isTablet || isXsWide)
          ? '550px'
          : (desktopMaxWidth || '650px'),
        padding: padding || '35px 0 15px 0', // Use padding prop if available
        justifyContent: (isFullWidth || (alignLeftOnDesktop && isDesktop)) ? 'flex-start' : undefined,
        marginLeft: (isFullWidth || (alignLeftOnDesktop && isDesktop)) ? 0 : undefined,
        marginRight: alignLeftOnDesktop && isDesktop ? 'auto' : undefined
      }}
    >
      <Grid
        container
        className={classes.suggestContainer}
        style={{
          flexWrap: 'nowrap',
          // md and desktop content capped; allow override. For full-width case force 100%.
          maxWidth: isFullWidth
            ? '100%'
            : (isTablet || isXsWide)
            ? '100%'
            : (desktopMaxWidth || '650px'),
          width: isFullWidth ? '100%' : undefined,
          ...(bigPaddingOnLargeScreens && isLargeScreen && {
            padding: '50px 40px'
          }),
          ...(mediumPaddingOnLargeScreens && isLargeScreen && {
            padding: '30px 25px'
          }),
          ...(suggestContainerPadding && { padding: suggestContainerPadding })
        }}
      >
        {!isModal && (
          <Grid item>
            <img src={suggestIcon} />
          </Grid>
        )}
        <Grid item>
          {isModal && <img src={suggestIcon} className={classes.suggestIcon} />}
          <Typography
            variant='body2'
            className={classes.suggestText}
            style={{ whiteSpace: 'pre-line' }}
          >
            {content ||
              "Lorem ipsum dolor sit amet consectetur adipisicing elit. Minus obcaecati, suscipit corporis fugit voluptates voluptatum impedit fugiat nulla voluptas numquam magni laborum unde iure ullam veniam. Dignissimos ut reprehenderit ex!"}
          </Typography>
        </Grid>
      </Grid>
    </div>
  );
}

export default withStyles(styles)(Suggest);
